import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './modules/core/components/login/login.component';
import { NewLoginComponent } from './modules/core/components/new-login/new-login.component';
import { CCAuthGuard } from '@maids/cc-erp-services';
import { CCRoutes } from '@maids/cc-lib/common';
import { APP_BASE_HREF } from '@angular/common';
import { environment } from 'src/environments/environment';
import { AppComponent } from './app.component';
import { UaePassComponent } from './modules/uae-pass/components/uae-pass/uae-pass.component';

const routes: CCRoutes = [
  { path: 'old-login', component: LoginComponent },
  { path: 'login', component: NewLoginComponent },
  { path: 'uaepass', component: UaePassComponent},
  {
    path: '',
    canLoad: [CCAuthGuard],
    canActivate: [CCAuthGuard],
    data: { label: 'Pages' },
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/main-angular-module/main-angular.module').then(
            (m) => m.MainAngularModule
          ),
        data: { label: '', disabled: true },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: false })],
  exports: [RouterModule],
  providers:[]
})
export class AppRoutingModule { }
